module.exports = __webpack_public_path__ + "static/img/logo-fastpay-bg.d62a3b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/logo-fastpay-bg.jpg
// module id = nAL5
// module chunks = 1